import { MobileSdkTestDetailsQueryVariables } from 'src/apps/mobile-sdk/services/queries/test-details/MobileSdkTestDetails.generated';

export const buildMobileSdkTestDetailsQueryVariables = (
	runId: string
): MobileSdkTestDetailsQueryVariables => {
	return {
		runId: { value: [runId] }
	};
};
